import Button from "../../components/button";
import { useScreenSize } from "../../hooks/useScreenSize";
import ReactHtmlParser from "react-html-parser";
import * as S from './styles'
import Modal from "../../components/modal";
import { useState } from "react";

const SectionMission = () => {
	const dimension = useScreenSize();
  const KEY_STORAGE_LOG = '@ESTACIO_FORTNITE';

  const [openModal, setOpenModal] = useState(false);
  const [modalMessage, setModalMessage] = useState(null);

  const onOpenModal = () => {
    const user = localStorage.getItem(KEY_STORAGE_LOG) || null;
    const logged = JSON.parse(user);

    if (logged) {
      setModalMessage`
        <p>Aqui está seu código de acesso ao Expedição ENEMVERSO. Entre no Fortnite no modo criativo, complete os mapas e concorra a bolsas de ensino.</p>
        <p>Código: 1138-6550-4225</p>
      `;
      setOpenModal(true);
    } else {
      setModalMessage(`<p>Ops, para pegar o código do jogo você precisa se cadastrar e estar logado.</p> `);
      setOpenModal(true);
    }
  };

  return (
    <S.SectionMission id="toMission" data-section="section_missao-enemverso">
      <div className="container">
        <div className="header-mission border">
          <div className="title">
            <h2>Você foi convocado para a Expedição ENEMVERSO </h2>
          </div>
          <p>Complete os desafios e concorra a bolsas integrais de Graduação</p>
        </div>

        <div className="container-video">
          <div className="card-video">
            <div className="video">
              <iframe
              width={825}
              height={368}
                src="https://www.youtube.com/embed/Ykt1uxbTe9I"
                title="Expedição ENEMVERSO"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
            
            <p>
              Já pensou se preparar para o ENEM enquanto joga? Com a Expedição
              ENEMVERSO criado no Fortnite isso é possível! E o melhor: sua partida
              vale a chance de ganhar bolsas de 100% no curso todo na Graduação
              Estácio.
            </p>
            <p>
              Confira o passo a passo e entre nessa jornada épica em busca do
              conhecimento.
            </p>
            
            <Button
              label="ACEITAR MISSÃO"
              fontSize={dimension.width >= 1024 ? "23" : "20"}
              height='86'
              width={dimension.width >= 1024 ? "414" : "222"}
              padding={dimension.width >= 1024 ? "0" : "25"}
              weight={900}
              dataElement="button_aceitar_missao"
              action={onOpenModal}
            />

            <p className='note'>
              Este evento não é patrocinado, apoiado ou administrado pela Epic
              Games, Inc.
            </p>
          </div>
        </div>
      </div>

      <Modal isOpen={openModal} onClose={() => setOpenModal(false)}>
        {ReactHtmlParser(modalMessage)}
      </Modal>
    </S.SectionMission>
  )
}

export default SectionMission